import { render } from "./Widget.vue?vue&type=template&id=5e48e1b2"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"
script.render = render

export default script